export default "__VITE_ASSET__78ba5f53__"